import React, { useEffect, useState, Fragment } from 'react';
import { Clock } from 'lucide-react';
function getInitialEnd() {
  if (typeof window === 'undefined') return Date.now() + 24 * 60 * 60 * 1000;
  const stored = window.localStorage.getItem('rs_offer_end');
  if (stored) {
    const ts = parseInt(stored, 10);
    if (ts > Date.now()) return ts;
  }
  const newEnd = Date.now() + 24 * 60 * 60 * 1000;
  window.localStorage.setItem('rs_offer_end', String(newEnd));
  return newEnd;
}
export function CountdownTimer() {
  const [endTs, setEndTs] = useState<number | null>(null);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    setEndTs(getInitialEnd());
    const interval = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(interval);
  }, []);
  if (!endTs) return null;
  const remaining = Math.max(0, endTs - now);
  const hours = Math.floor(remaining / (1000 * 60 * 60));
  const minutes = Math.floor(remaining / (1000 * 60) % 60);
  const seconds = Math.floor(remaining / 1000 % 60);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="inline-flex flex-col items-center gap-3 mb-6" data-id="element-186">
      <div className="inline-flex items-center gap-2 text-yellow-300 font-bold text-sm uppercase tracking-wider" data-id="element-187">
        <Clock className="w-4 h-4 animate-pulse" data-id="element-188" />
        Offer Ends In
      </div>
      <div className="flex items-center gap-2 md:gap-3" data-id="element-189">
        {[{
        label: 'Hours',
        value: hours
      }, {
        label: 'Min',
        value: minutes
      }, {
        label: 'Sec',
        value: seconds
      }].map((unit, i) => <Fragment key={unit.label} data-id="element-190">
            <div className="flex flex-col items-center bg-red-600 text-white rounded-lg px-3 py-2 md:px-4 md:py-3 shadow-lg border-2 border-yellow-300 min-w-[60px] md:min-w-[80px]" data-id="element-191">
              <span className="text-2xl md:text-4xl font-extrabold leading-none tabular-nums" data-id="element-192">
                {pad(unit.value)}
              </span>
              <span className="text-[10px] md:text-xs uppercase tracking-wider mt-1 text-yellow-200" data-id="element-193">
                {unit.label}
              </span>
            </div>
            {i < 2 && <span className="text-yellow-300 text-2xl md:text-3xl font-extrabold animate-pulse" data-id="element-194">
                :
              </span>}
          </Fragment>)}
      </div>
    </div>;
}